import TotalRating from '../TotalRating'
import { useState } from 'react'
import { useTranslation } from 'next-i18next'

export default function PluginComment ({ rating }) {
  const [shouldReadMore, setShouldReadMore] = useState(false)
  const { t } = useTranslation('plugins')

  return (
    <div className="d-flex flex-column">
      <div className="col-12 mt-5">
        <div className="row align-items-center justify-content-between">
          <div className="d-flex align-items-center justify-content-between">
            <span>
              <TotalRating rating={rating.rating_total} />
            </span>
            <span>
              <small className="text-muted">{rating.created_at}</small>
            </span>
          </div>
          <strong className="text-dark mt-2">{rating.title}</strong>
          <p className="text-muted mt-2">
            {(!shouldReadMore && rating.rating_text.length > 200) && (rating.rating_text.substr(0, 200) + ' ...')}
            {(!shouldReadMore && rating.rating_text.length < 200) && (rating.rating_text) }
            {shouldReadMore && (rating.rating_text)}
          </p>
          <div className="row ms-0 d-flex justify-content-between">
            <div className="col-auto p-0">
              {(!shouldReadMore && rating.rating_text.length > 200) && (
                <button
                  className="btn btn-link text-start ps-0"
                  onClick={() => setShouldReadMore(true)}
                >
                  {t('detail.read_more')}
                </button>
              )}
              {shouldReadMore && (
                <button
                  className="btn btn-link text-start ps-0"
                  onClick={() => setShouldReadMore(false)}
                >
                  {t('detail.read_less')}
                </button>
              )}
            </div>
            <div className="col-auto p-0">
              <a className="fs-5">{rating.user.full_name}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
